import { useRoute, useRouter } from "vue-router";

// Helper to get router instance when needed
function getRouter() {
  return useRouter();
}

// Helper to get route instance when needed
function getRoute() {
  return useRoute();
}

export function addParamToUrl(key, value) {
  const router = getRouter();
  const route = getRoute();
  
  router.replace({ 
    query: { 
      ...route.query,
      [key]: value 
    }
  });
}

export function useFilterEnterSelect(selectRef, modelValueRef, labelKey = 'label', valueKey = 'id') {
  log.info(5,"🔥 useFilterEnterSelect", selectRef, modelValueRef, labelKey, valueKey)
  // keep track of the last handler so we can clean up if the component unmounts
  let lastHandler = null

  const onFilter = (event) => {
    // wait for the filtered options to render
    nextTick(() => {
      // grab the actual <input> that PrimeVue is using
      const input = event.originalEvent?.target
      if (!input || !selectRef.value) return

      // define a stable handler so we can remove it later
      lastHandler = (e) => {
        log.info(5,"🔥 lastHandler", e)
        if (e.key !== 'Enter') return
        const opts = selectRef.value.visibleOptions || []
        log.info(5,"🔥 onFilter", opts)
        let pick

        // if something is keyboard-focused, match on its text
        const focused = document.querySelector('[data-p-focused="true"]')
        if (focused) {
          log.info(5,"🔥 focused", focused)
          log.info(5,"Text Content",focused.textContent)
          pick = opts.find(o => labelKey ? o[labelKey] === focused.textContent : o === focused.textContent)
          log.info(5,"🔥 pick", pick)
        }

        // otherwise default to the first one
        if (!pick && opts.length) {
          log.info(5,"🔥 default to the first one", opts[0])
          pick = opts[0]
        }

        if (pick) {
          let result = valueKey ? pick[valueKey] : pick
          log.info(5,"🔥 result", result)
          modelValueRef.value = result
        }

        // remove after first use
        input.removeEventListener('keydown', lastHandler)
      }

      input.addEventListener('keydown', lastHandler)
    })
  }

  onBeforeUnmount(() => {
    // in case the component disappears mid-filter
    if (lastHandler && selectRef.value) {
      const inp = selectRef.value.$el.querySelector('input')
      inp?.removeEventListener('keydown', lastHandler)
    }
  })

  return { onFilter }
}

export function getUrlParameter(name) {
  const url = window.location.href;
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  const results = regex.exec(url);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export function setAppDocumentTitle(title) {
  // log.info(5,"🔥 setAppDocumentTitle", title)
  if (window.VITE_DEVELOPMENT) {
    title = '🟥 ' + title
  }
  document.title = title
}

export function focus(id, delay = 10) {
  // log.info(5,"🔎 focus", id, document.getElementById(id));
  setTimeout(() => {
    document.getElementById(id)?.focus();
  }, delay);
}

export function focusAndSelect(id, delay = 10) {
  // log.info(5,"🔎 focusAndSelect", id, document.getElementById(id));
  focus(id, delay);
  setTimeout(() => {
    document.getElementById(id)?.select();
  }, delay);
}

export function highlightBox(id, delay = 10, length = 2000) {
  setTimeout(() => {
    const el = document.getElementById(id);
    if (el) {
      el.classList.add('focusHighlightBox');
      setTimeout(() => {
        el.classList.remove('focusHighlightBox');
      }, length);
    }
  }, delay);
}

export function focusAndHighlight(id, delay = 10, length = 2000, error = false) {
  log.info(5,"🔎 focusAndHighlight", id, document.getElementById(id));
  focus(id, delay);
  setTimeout(() => {
    const el = document.getElementById(id);
    if (el) {
      el.classList.add(error ? 'focusErrorHighlight' : 'focusHighlight');
      setTimeout(() => {
        el.classList.remove(error ? 'focusErrorHighlight' : 'focusHighlight');
      }, length);
    }
  }, delay);
}

export function toggleAutocomplete(id, on, delay = 10) {
  setTimeout(() => {
    const element = document.getElementById(id);
    if (element) {
      element.autocomplete = on ? "on" : "off";
    }
  }, delay);
}

export function toggleAutocompleteByElement(element, on, delay = 10) {
  setTimeout(() => {
    element.autocomplete = on ? "on" : "off";
  }, delay);
}

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}